import {Navigate} from 'react-router-dom';
import {LOGIN, PRIVATE_USER} from 'config/router/paths';
import {useAuthContext} from 'contexts/authContext';

export default function PrivateRedirector() {
  const {isAuthenticated} = useAuthContext();
  if (!isAuthenticated) {
    return <Navigate to={LOGIN} />;
  }else{
    return <Navigate to={PRIVATE_USER} />;
  }
}
